import(/* webpackMode: "eager" */ "/opt/build/repo/app/error.tsx")